import { PageHero } from "../components/common";
import { COMPANY } from "../lib/constants";

function Legal({ title, eyebrow, children }) {
  return (
    <div>
      <PageHero eyebrow={eyebrow} title={title} />
      <section className="bg-white">
        <div className="ubm-container py-16 max-w-3xl prose-legal">
          <div className="space-y-6 text-charcoal-600 leading-relaxed">{children}</div>
        </div>
      </section>
    </div>
  );
}

const H = ({ children }) => <h2 className="text-xl font-semibold text-charcoal-900 mt-8 mb-2">{children}</h2>;

export function Privacy() {
  return (
    <div data-testid="privacy-page">
      <Legal eyebrow="Legal" title="Privacy Policy">
        <p>United Building Maintenance and Residential Cleaning Services ("we," "us") respects your privacy. This policy explains how we collect, use, and protect your information.</p>
        <H>Information We Collect</H>
        <p>We collect information you provide through our forms — including your name, contact details, property address, and booking details — as well as employment application information when you apply for a position.</p>
        <H>How We Use It</H>
        <p>We use your information to schedule and deliver cleaning services, process payments, respond to inquiries, and evaluate employment applications. We do not sell your personal information.</p>
        <H>Payment Information</H>
        <p>We do not store credit or debit card numbers on our website. All payments are processed securely through Stripe, a PCI-compliant payment processor.</p>
        <H>Data Security</H>
        <p>We use reasonable administrative and technical safeguards, including secure authentication and encrypted connections (SSL), to protect your information.</p>
        <H>Contact</H>
        <p>Questions about this policy? Contact us at {COMPANY.email} or {COMPANY.phoneDisplay}.</p>
      </Legal>
    </div>
  );
}

export function Terms() {
  return (
    <div data-testid="terms-page">
      <Legal eyebrow="Legal" title="Terms & Conditions">
        <p>By using this website and our services, you agree to the following terms.</p>
        <H>Services</H>
        <p>Commercial cleaning is provided under custom quotes and agreements. Residential cleaning may be booked and paid for online. Prices shown online are estimates and may be adjusted based on the actual condition and size of the property.</p>
        <H>Payments</H>
        <p>Residential bookings may require full payment, a deposit, or payment after service, as configured at the time of booking. All card payments are processed securely by Stripe.</p>
        <H>Residential Cancellation Policy</H>
        <p>We ask for at least 48 hours' notice to cancel or reschedule a residential appointment. Cancellations made with less notice may be subject to a fee. Deposits may be non-refundable within the cancellation window. We will always work with you in good faith.</p>
        <H>Employment Applications</H>
        <p>Information submitted through our employment application is used solely for hiring purposes and handled confidentially.</p>
        <H>Liability</H>
        <p>We carry out our work with professional care. Please report any concerns within 24 hours so we can make it right.</p>
        <H>Contact</H>
        <p>Questions? Contact us at {COMPANY.email} or {COMPANY.phoneDisplay}.</p>
      </Legal>
    </div>
  );
}
